<div class="scaffold-bool">
    <p-checkbox binary="true" [inputId]="item.label" (onChange)="updateCheck()" [(ngModel)]="switchValue" [disabled]="checkDisable()">
    </p-checkbox>
    <label for="item.label">
      {{item.translation_key_label||item.label| translation|translationFromString | transformText :item?.text_transform_label}} 
      <span *ngIf="item.helpText||item.translation_key_help_text" > <i pTooltip="{{item.translation_key_help_text||item.helpText| translation|translationFromString | transformText :item?.text_transform_help_text}}" class="fas fa-question-circle"></i> </span>
    </label >

</div>